import VNode from './vnode';

module.exports = class XNode extends VNode {
  constructor({ xml = '' }) {
    super({});
    this.xml = xml;
  }

  render() {
    const div = document.createElement('div');
    div.innerHTML = this.xml;
    return div;
  }
}
